import { render } from "./Faxian.vue?vue&type=template&id=1e789a9b&scoped=true"
import script from "./Faxian.vue?vue&type=script&lang=js"
export * from "./Faxian.vue?vue&type=script&lang=js"

import "./Faxian.vue?vue&type=style&index=0&id=1e789a9b&lang=css"
import "./Faxian.vue?vue&type=style&index=1&id=1e789a9b&scoped=true&lang=css"

import exportComponent from "E:\\work\\copy\\work\\fa\\tgkw\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e789a9b"]])

export default __exports__